import React, { Component } from 'react'
import OneLineEditor from '../components/OneLineEditor'
import EstimationActions from '../libs/EstimationActions'
import Utils from '../libs/Utils'

class MaterialCostPrintTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation()
    }
  }
  materiaKingaku (data, category) {
    if (category.code === 'Mokuzai') {
      return data.suuryou * data.materialMokuzaiUnitPrice
    } else if (category.code === 'Shoumouhin') {
      return data.suuryou * data.materialShoumouhinUnitPrice
    } else if (category.code === 'Kouseizai') {
      return data.suuryou * data.materialKouseizaiUnitPrice
    }
  }
  renderDetailTable (list, start, end, category, tableOffset, katawakuSuuryou, goukei, isPrintGoukei) {
    const inputStyle = {
      backgroundColor: 'FFFFFF',
      cursor: 'normal'
    }
    const tableTitle = (start === 0) ? <p className='kw-pad1 kw-clear'><br />{category.name}</p> : ''
    const viewListId = 'uchiwake' + category.code + 'List'
    const unitPriceName = 'material' + category.code + 'UnitPrice'
    const noteName = 'meterial' + category.code + 'Note'
    const goukeiTr = isPrintGoukei ? (
      <tr>
        <td className='kw-top-double'>小計</td>
        <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='kw-top-double kw-ln' />
        <td className='kw-top-double text-right'>{Utils.convKingaku(goukei / katawakuSuuryou, 1)}</td>
        <td className='kw-top-double text-right'>{Utils.convKingaku(goukei)}</td>
        <td className='kw-top-double' />
      </tr>
    ) : []

    const uchiwakeList = list.slice(start, end).map((data, i) => {
      const kwDoubble = (i === 0) ? 'kw-top-double ' : ''
      const dataLength = end - start - 1
      const kwLast = (i === dataLength && list.length === end) ? 'kw-bottom-double ' : ''
      return (
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={'uchiwake' + category.code + 'List_' + tableOffset + '_' + i}>
          <td className={kwDoubble + kwLast} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='name' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-center'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute='tani' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute={unitPriceName} isCommaSeparated isNum prefix='¥' decimalPlaces='1' textAlign='right' viewListId={viewListId} /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(this.materiaKingaku(data, category))}</td>
          <td className={kwDoubble + kwLast + 'text-right'} style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={start + i} bindingDataAttribute={noteName} viewListId={viewListId} /></td>
        </tr>
      )
    })
    return (
      <div className='kw-detail' key={'uchiwake' + category.name + 'List_' + tableOffset}>
        {tableTitle}
        <table>
          <thead>
            <tr>
              <th className='kw-name' />
              <th className='kw-person' />
              <th className='kw-unit' />
              <th className='kw-yen-unit-price' />
              <th className='kw-yen1' />
              <th className='kw-note' />
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>名称</th>
              <th>数量</th>
              <th>単位</th>
              <th>単価</th>
              <th>金額</th>
              <th>備考</th>
            </tr>
            {uchiwakeList}
            {goukeiTr}
          </tbody>
        </table>
      </div>
    )
  }
  render () {
    const inputStyle = {
      backgroundColor: 'FFFFFF',
      cursor: 'normal'
    }
    var data = this.state.data.uchiwakeList
    let mokuzaiGoukei = 0
    let shoumouhinGoukei = 0
    let kousezaiGoukei = 0
    let katawakuSuuryou = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i].isKatawakuSuuryou) {
        katawakuSuuryou += Math.round(data[i].suuryou)
      }
      mokuzaiGoukei += Math.round(data[i].materialMokuzaiUnitPrice * data[i].suuryou)
      shoumouhinGoukei += Math.round(data[i].materialShoumouhinUnitPrice * data[i].suuryou)
      kousezaiGoukei += Math.round(data[i].materialKouseizaiUnitPrice * data[i].suuryou)
    }

    if (!this.state.data.materialCostDetailInputMode) {
      mokuzaiGoukei = this.state.data.materialMokuzaiUnitPrice * katawakuSuuryou
      shoumouhinGoukei = this.state.data.materialShoumouhinUnitPrice * katawakuSuuryou
      kousezaiGoukei = this.state.data.materialKouseizaiUnitPrice * katawakuSuuryou
    }

    const totalTable = (
      <table>
        <thead>
          <tr>
            <th className='kw-name' />
            <th className='kw-person' />
            <th className='kw-unit' />
            <th className='kw-yen-unit-price' />
            <th className='kw-yen1' />
            <th className='kw-note' />
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
            <th>備考</th>
          </tr>
          <tr>
            <td className='kw-top-double'>木材費</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-center'>㎡</td>
            <td className='kw-top-double text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
              ? Utils.convKingaku(mokuzaiGoukei / katawakuSuuryou)
              : <OneLineEditor bindingDataAttribute='materialMokuzaiUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
            }
            </td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei)}</td>
            <td className='kw-top-double' style={inputStyle}><OneLineEditor bindingDataAttribute='materialMokuzaiNote' /></td>
          </tr>
          <tr>
            <td>消耗品費</td>
            <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='text-center'>㎡</td>
            <td className='text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
              ? Utils.convKingaku(shoumouhinGoukei / katawakuSuuryou)
              : <OneLineEditor bindingDataAttribute='materialShoumouhinUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
            }
            </td>
            <td className='text-right'>{Utils.convKingaku(shoumouhinGoukei)}</td>
            <td style={inputStyle}><OneLineEditor bindingDataAttribute='materialShoumouhinNote' /></td>
          </tr>
          <tr>
            <td className='kw-bottom-double'>鋼製材損料</td>
            <td className='kw-bottom-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-bottom-double text-center'>㎡</td>
            <td className='kw-bottom-double text-right' style={inputStyle}>
              {this.state.data.materialCostDetailInputMode
                                  ? Utils.convKingaku(kousezaiGoukei / katawakuSuuryou)
                                  : <OneLineEditor bindingDataAttribute='materialKouseizaiUnitPrice' />
                                }</td>
            <td className='kw-bottom-double text-right'>
              {Utils.convKingaku(kousezaiGoukei)}
            </td>
            <td className='kw-bottom-double' style={inputStyle}><OneLineEditor bindingDataAttribute='materialKouseizaiNote' /></td>
          </tr>
          <tr>
            <td className='kw-top-double'>合計</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
            <td className='kw-top-double kw-ln' />
            <td className='kw-top-double text-right'>{Utils.convKingaku((mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei) / katawakuSuuryou)}</td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei)}</td>
            <td className='kw-top-double' />
          </tr>
        </tbody>
      </table>
    )

    const pages = []
    const firsPageDetailTable = []
    const dataList = this.state.data.uchiwakeList

    // 木材

    let printedMokuzaiDataCount = 0
    let firstPageMokuzaiDataCount = 14
    printedMokuzaiDataCount = (dataList.length < firstPageMokuzaiDataCount) ? dataList.length : firstPageMokuzaiDataCount
    const detail = this.renderDetailTable(dataList, 0, printedMokuzaiDataCount, {code: 'Mokuzai', name: '木材費'}, 0, katawakuSuuryou, mokuzaiGoukei, dataList.length <= printedMokuzaiDataCount)
    firsPageDetailTable.push(detail)

    // 消耗品

    let printedShoumouhinDataCount = 0

    if (dataList.length <= 10) {
      printedShoumouhinDataCount = 11 - dataList.length
      const detail = this.renderDetailTable(dataList, 0, printedShoumouhinDataCount, {code: 'Shoumouhin', name: '消耗品費'}, 0, katawakuSuuryou, shoumouhinGoukei, dataList.length <= 5)
      firsPageDetailTable.push(detail)
    }

    // 鋼製材損料

    let printedKouseizaiDataCount = 0

    if (dataList.length <= 3) {
      printedKouseizaiDataCount = (dataList.length === 2) ? 2 : 1
      const detail = this.renderDetailTable(dataList, 0, printedKouseizaiDataCount, {code: 'Kouseizai', name: '鋼製材損料'}, 0, katawakuSuuryou, kousezaiGoukei, dataList.length <= 2)
      firsPageDetailTable.push(detail)
    }

    const firstPage =
    (
      <div key='firstPage'>
        <article className='kw-katawaku-art'>
          <section className='kw-print-page'>
            <div className='kw-container'>
              <div className='kw-materialview'>
                <div className='kw-detail'>
                  <h5>材料費の計算</h5>
                  <p className='kw-pad1 kw-clear'>材料費計</p>
                  {totalTable}
                  {firsPageDetailTable}
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>
      )
    pages.push(firstPage)

    const pageMaxDataCount = 17
    let pageOffset = 0
    while (dataList.length - printedKouseizaiDataCount > 0) {
      pageOffset++
      let pageExtraDataCount = pageMaxDataCount
      const detailTable = []
      if (dataList.length - printedMokuzaiDataCount > 0) {
        const printingMokuzaiDataCount = (dataList.length - printedMokuzaiDataCount > pageMaxDataCount) ? pageMaxDataCount : (dataList.length - printedMokuzaiDataCount)
        pageExtraDataCount -= printingMokuzaiDataCount
        const start = printedMokuzaiDataCount
        const end = printedMokuzaiDataCount + printingMokuzaiDataCount
        printedMokuzaiDataCount += printingMokuzaiDataCount
        const detail = this.renderDetailTable(dataList, start, end, {code: 'Mokuzai', name: '木材費'}, pageOffset, katawakuSuuryou, mokuzaiGoukei, dataList.length === printedMokuzaiDataCount)
        detailTable.push(detail)
      }
      if (pageExtraDataCount > 0) {
        if (dataList.length - printedShoumouhinDataCount > 0) {
          const printingShoumouhinDataCount = (dataList.length - printedShoumouhinDataCount > pageExtraDataCount) ? pageExtraDataCount : (dataList.length - printedShoumouhinDataCount)
          pageExtraDataCount -= printingShoumouhinDataCount
          const start = printedShoumouhinDataCount
          const end = printedShoumouhinDataCount + printingShoumouhinDataCount
          printedShoumouhinDataCount += printingShoumouhinDataCount
          const detail = this.renderDetailTable(dataList, start, end, {code: 'Shoumouhin', name: '消耗品費'}, pageOffset, katawakuSuuryou, shoumouhinGoukei, dataList.length === printedShoumouhinDataCount)
          detailTable.push(detail)
        }
      }
      if (pageExtraDataCount > 0) {
        if (dataList.length - printedKouseizaiDataCount > 0) {
          const printingKouseizaiDataCount = (dataList.length - printedKouseizaiDataCount > pageExtraDataCount) ? pageExtraDataCount : (dataList.length - printedKouseizaiDataCount)
          pageExtraDataCount -= printingKouseizaiDataCount
          const start = printedKouseizaiDataCount
          const end = printedKouseizaiDataCount + printingKouseizaiDataCount
          printedKouseizaiDataCount += printingKouseizaiDataCount
          const detail = this.renderDetailTable(dataList, start, end, {code: 'Kouseizai', name: '鋼製材損料'}, pageOffset, katawakuSuuryou, kousezaiGoukei, dataList.length === printedKouseizaiDataCount)
          detailTable.push(detail)
        }
      }
      pages.push(
        <div key={pages.length}>
          <article className='kw-katawaku-art'>
            <section className='kw-print-page'>
              <div className='kw-container'>
                <div className='kw-materialview'>
                  <div className='kw-detail'>
                    {detailTable}
                  </div>
                </div>
              </div>
            </section>
          </article>
        </div>
      )
    }

    return pages
  }
}

export default MaterialCostPrintTab



// WEBPACK FOOTER //
// ./src/company_user/print/MaterialCostPrintTab.js